<script>
    import {
        Slider,
        Dropdown,
        Checkbox,
        RadioButtonGroup,
        RadioButton,
        NumberInput,
        TextInput,
    } from "carbon-components-svelte";
    import Info from "./Info.svelte";
    export let type,
        paramElement,
        paramProperties,
        scrollHeightMin,
        changed,
        updateVis;
    export let changeScrollMin = (type) => {
        if (type == "designParam") {
            // this is declared in Param.svelte
            scrollHeightMin = 300;
        }
    };
    const dropdownItems = (paramProperties) =>
        paramProperties.enum.map((x, i) => ({
            id: x,
            text: paramProperties.values[i],
        }));
    export let changeHandler = (type, component) => {
        if (type == "designParam") {
            changed = true;
        }
        if (type == "visParam") {
            updateVis();
        }
    };
</script>

<div id="param_component">
    {#if paramProperties.component == "slider"}
        <br />
        <Info text={paramProperties.description} />
        <Slider
            bind:value={paramElement}
            labelText={paramProperties.title}
            min={paramProperties.minimum}
            max={paramProperties.maximum}
            step={paramProperties.step}
            on:change={changeHandler(type, paramProperties.component)}
        />
    {:else if paramProperties.component == "numberinput"}
        <br />
        <Info text={paramProperties.description} />
        <NumberInput
            bind:value={paramElement}
            label={paramProperties.title}
            min={paramProperties.minimum}
            max={paramProperties.maximum}
            invalidText="Number must be between {paramProperties.minimum} and {paramProperties.maximum}"
            hideSteppers
            on:change={changeHandler(type, paramProperties.component)}
        />
    {:else if paramProperties.component == "textinput"}
        <br />
        <Info text={paramProperties.description} />
        <TextInput
            bind:value={paramElement}
            labelText={paramProperties.title}
            placeholder={paramProperties.default}
            on:change={changeHandler(type, paramProperties.component)}
        />
    {:else if paramProperties.component == "checkbox"}
        <br />
        <Info text={paramProperties.description} />
        <Checkbox
            bind:checked={paramElement}
            labelText={paramProperties.title}
            on:check={changeHandler(type, paramProperties.component)}
        />
    {:else if paramProperties.component == "radiobutton"}
        <br />
        <Info text={paramProperties.description} />
        <RadioButtonGroup
            bind:selected={paramElement}
            legendText={paramProperties.title}
        >
            {#each paramProperties.enum as val, i}
                <RadioButton
                    labelText={paramProperties.values[i]}
                    value={val}
                    on:change={changeHandler(type, paramProperties.component)}
                />
            {/each}
        </RadioButtonGroup>
    {:else if paramProperties.component == "dropdown"}
        <br />
        <Info text={paramProperties.description} />
        <div on:click={changeScrollMin(type)}>
            <Dropdown
                bind:selectedId={paramElement}
                titleText={paramProperties.title}
                items={dropdownItems(paramProperties)}
                on:select={changeHandler(type, paramProperties.component)}
            />
        </div>
    {:else}
        <div>
            tbd: {paramProperties.id} - {paramProperties.description}
        </div>
        <br />
    {/if}
</div>

<style>
    #param_component {
        font-family: Arial, sans-serif;
    }
</style>
